export default __webpack_public_path__ + "static/media/Bezeni-COVER.c60634a6.jpg";